var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSyncDesktop = function SvgSyncDesktop(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "sync_desktop_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sync_desktop_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.596 17.116H20v-2.558h-5.404zm-.25 1.5q-.52 0-.885-.365a1.2 1.2 0 0 1-.365-.886v-3.057q0-.522.365-.886.364-.364.885-.364h5.904q.52 0 .886.364.364.364.364.886v3.057q0 .522-.364.886a1.2 1.2 0 0 1-.886.364zm-1.5 2.884a.73.73 0 0 1-.534-.216.73.73 0 0 1-.216-.534q0-.32.216-.535a.73.73 0 0 1 .534-.215h8.904q.318 0 .534.216a.73.73 0 0 1 .216.534q0 .32-.216.535a.73.73 0 0 1-.534.215zM5.75 12.039q0 1.436.59 2.645.591 1.21 1.871 2.343v-1.989q0-.318.216-.534a.73.73 0 0 1 .535-.215q.318 0 .534.215a.73.73 0 0 1 .215.535v3.73q0 .383-.26.644a.88.88 0 0 1-.643.26H5.077a.73.73 0 0 1-.534-.216.73.73 0 0 1-.216-.534q0-.32.216-.534a.73.73 0 0 1 .534-.216h2.158q-1.535-1.33-2.26-2.861a7.54 7.54 0 0 1-.725-3.269q0-2.293 1.194-4.15t3.102-2.827a.61.61 0 0 1 .567-.027.66.66 0 0 1 .389.428.8.8 0 0 1-.033.588.94.94 0 0 1-.392.435 6.24 6.24 0 0 0-2.412 2.274 6.1 6.1 0 0 0-.915 3.275m10.039-5.056v1.979q0 .318-.216.534a.73.73 0 0 1-.535.216.73.73 0 0 1-.534-.216.73.73 0 0 1-.215-.534V5.23q0-.383.26-.644a.88.88 0 0 1 .643-.26h3.731q.319 0 .535.216a.73.73 0 0 1 .215.534q0 .32-.215.535a.73.73 0 0 1-.535.215h-2.158q1.114.975 1.745 1.97.633.996.938 2.076a.59.59 0 0 1-.076.543.75.75 0 0 1-.482.313.69.69 0 0 1-.56-.112 1 1 0 0 1-.363-.477 5.9 5.9 0 0 0-.761-1.59q-.502-.74-1.417-1.567"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSyncDesktop);
export default ForwardRef;